import { createFormHookContexts } from "@tanstack/react-form";

/** Contexts shared by every field adapter; `useFieldContext` is how an adapter reads its field. */
export const { fieldContext, formContext, useFieldContext, useFormContext } = createFormHookContexts();
